import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useWeeklyProgressData } from "./weekly-progress/useWeeklyProgressData";
import { DaysTab } from "./weekly-progress/DaysTab";
import { HeatmapTab } from "./weekly-progress/HeatmapTab";
import { PieTab } from "./weekly-progress/PieTab";
import { Insights } from "./weekly-progress/Insights";

interface Props {
  childId: string;
  familyId: string;
  childCreatedAt: string;
}

export function WeeklyProgressCard({ childId, familyId, childCreatedAt }: Props) {
  const { vm, isLoading } = useWeeklyProgressData({
    childId,
    familyId,
    childCreatedAt,
  });

  if (isLoading || !vm) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-20 w-full rounded-2xl" />
        <Skeleton className="h-48 w-full rounded-2xl" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Compact insights bar */}
      <Card>
        <CardContent className="px-4 py-3">
          <Insights insights={vm.insights} />
        </CardContent>
      </Card>

      {/* Charts – tabbed */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-semibold">Detaljer</CardTitle>
        </CardHeader>
        <CardContent className="px-2 pb-3">
          <Tabs defaultValue="days">
            <TabsList className="w-full">
              <TabsTrigger value="days" className="flex-1 text-xs">
                Dager
              </TabsTrigger>
              <TabsTrigger value="heatmap" className="flex-1 text-xs">
                Heatmap
              </TabsTrigger>
              <TabsTrigger value="pie" className="flex-1 text-xs">
                Fordeling
              </TabsTrigger>
            </TabsList>
            <TabsContent value="days">
              <DaysTab vm={vm} />
            </TabsContent>
            <TabsContent value="heatmap">
              <HeatmapTab vm={vm} />
            </TabsContent>
            <TabsContent value="pie">
              <PieTab vm={vm} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}
